var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWheelChair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 152,
    viewBox: "0 0 153 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333008,
    width: 152,
    height: 152,
    rx: 76,
    fill: "#FAFAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5365 111.275C85.7642 111.275 94.0554 102.965 94.0554 92.7134C94.0554 82.4623 85.7642 74.1521 75.5365 74.1521C65.3088 74.1521 57.0176 82.4623 57.0176 92.7134C57.0176 102.965 65.3088 111.275 75.5365 111.275Z",
    fill: "#E6E5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2786 45.9282H53.8457V80.8129H83.2786V45.9282Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.208 82.6053H60.1149C55.0875 82.6053 51.1523 78.8612 51.1523 74.2368H104.789L107.208 82.6053Z",
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2288 105.505C88.5288 105.505 87.8818 105.038 87.6908 104.327L80.5209 77.8643C79.8314 75.4036 78.4208 74.2581 76.0874 74.2581H51.194V44.0827C51.194 42.3221 49.7621 40.8902 48.0014 40.8902H40.4709C39.5905 40.8902 38.8799 40.1796 38.8799 39.2992C38.8799 38.4189 39.5905 37.7083 40.4709 37.7083H48.0014C51.5122 37.7083 54.3759 40.5614 54.3759 44.0827V71.0762H76.0874C79.8633 71.0762 82.5255 73.1869 83.5967 77.0158L90.7667 103.49C91.0001 104.338 90.4909 105.208 89.6424 105.441C89.5045 105.484 89.3667 105.494 89.2288 105.494V105.505Z",
    fill: "#B1B0F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.383 105.505C111.683 105.505 111.036 105.038 110.845 104.327L103.707 77.9704C102.392 74.8839 101.024 74.2581 99.2417 74.2581H82.7168V44.0827C82.7168 42.3221 81.2849 40.8902 79.5243 40.8902H73.3195C72.4391 40.8902 71.7285 40.1796 71.7285 39.2992C71.7285 38.4189 72.4391 37.7083 73.3195 37.7083H79.5243C83.035 37.7083 85.8988 40.5614 85.8988 44.0827V71.0762H99.2417C102.721 71.0762 105.012 72.8475 106.687 76.8355L106.762 77.037L113.932 103.5C114.165 104.349 113.656 105.218 112.807 105.452C112.669 105.494 112.532 105.505 112.394 105.505H112.383Z",
    fill: "#B1B0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.833 101.814H101.299V106.343H114.833V101.814Z",
    fill: "#B1B0F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.833 101.814H105.266V106.343H114.833V101.814Z",
    fill: "#8E8CEE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4724 95.6458C73.4724 105.08 65.8438 112.725 56.4359 112.725C47.0281 112.725 39.3994 105.08 39.3994 95.6458C39.3994 86.2121 47.0281 78.5667 56.4359 78.5667C65.8438 78.5667 73.4724 86.2121 73.4724 95.6458Z",
    fill: "white",
    stroke: "#B1B0F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4362 114.292C46.1852 114.292 37.833 105.929 37.833 95.6459C37.833 85.3629 46.1852 77 56.4362 77C66.6872 77 75.0394 85.3629 75.0394 95.6459C75.0394 105.929 66.6872 114.292 56.4362 114.292ZM56.4362 79.1334C47.3586 79.1334 39.9664 86.5363 39.9664 95.6459C39.9664 104.755 47.3586 112.158 56.4362 112.158C65.5138 112.158 72.906 104.755 72.906 95.6459C72.906 86.5363 65.5245 79.1334 56.4362 79.1334Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4357 98.2916C57.8742 98.2916 59.0403 97.107 59.0403 95.6458C59.0403 94.1846 57.8742 93 56.4357 93C54.9972 93 53.8311 94.1846 53.8311 95.6458C53.8311 97.107 54.9972 98.2916 56.4357 98.2916Z",
    fill: "#B1B0F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4362 114.292C46.1852 114.292 37.833 105.929 37.833 95.6459C37.833 85.3629 46.1852 77 56.4362 77C66.6872 77 75.0394 85.3629 75.0394 95.6459C75.0394 105.929 66.6872 114.292 56.4362 114.292ZM56.4362 79.1334C47.3586 79.1334 39.9664 86.5363 39.9664 95.6459C39.9664 104.755 47.3586 112.158 56.4362 112.158C65.5138 112.158 72.906 104.755 72.906 95.6459C72.906 86.5363 65.5245 79.1334 56.4362 79.1334Z",
    fill: "#B1B0F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6913 104.338L81.8047 82.6055H85.1139L90.7565 103.479L87.6913 104.338Z",
    fill: "#B1B0F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8702 101.814H88.4229V106.343H98.8702V101.814Z",
    fill: "#B1B0F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8707 101.814H92.0508V106.343H98.8707V101.814Z",
    fill: "#8E8CEE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6997 113.248C87.6286 113.248 90.003 110.807 90.003 107.796C90.003 104.785 87.6286 102.344 84.6997 102.344C81.7708 102.344 79.3965 104.785 79.3965 107.796C79.3965 110.807 81.7708 113.248 84.6997 113.248Z",
    fill: "#B1B0F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M114.833 106.258C114.833 109.27 112.457 111.71 109.53 111.71C106.602 111.71 104.227 109.27 104.227 106.258",
    fill: "#B1B0F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelChair);
export default __webpack_public_path__ + "static/media/wheelChair.b07d9398e5663e0ba4dc5a2f3ce45597.svg";
export { ForwardRef as ReactComponent };